import React, { useEffect, useState, useRef } from 'react';
import { Button, Divider, Grid, Typography, TextField, MenuItem, Paper, Box, IconButton, Card, CardHeader, CardContent, Select, FormControl, Link, Tooltip, Dialog, DialogContent, DialogTitle, CircularProgress } from '@mui/material';
import 'react-datepicker/dist/react-datepicker.css';
import { SSPCommonButton, SSPCommonVideo } from '../../CommonComponents';
import { StyledDatePicker, boxSX, styles } from './Styles'
import { post } from "../../services";
import Cookies from "js-cookie";
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import axios from "axios";
import moment from 'moment';
import { Download } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
const base = "https://";

const CreateTransferReqest = ({ }) => {
    const getCurrentDate = () => {
        return new Date();
    };
    // const [selectedOption, setSelectedOption] = useState("Last 7 days");
    const [selectedOption, setSelectedOption] = useState("Select Creation Date");

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const currentDate = getCurrentDate();
    const [loc, setLoc] = useState("");
    const [status, setStatus] = useState('');
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const id = Cookies.get("ssp_id");
    const domain_id = Cookies.get("ssp_domain_id");
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [row, setRows] = useState([]);
    const [viewReasonRow, setViewReasonRow] = useState(null);
    const [statusOptions, setStatusOptions] = useState([]);
    const fileInputRef = useRef(null);
    const today = currentDate;


    useEffect(() => {
        const currentDate = new Date();
        const lastWeekDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        setStartDate(lastWeekDate);
        setEndDate(currentDate);
    }, []);

    useEffect(() => {
        rowFetch();
    }, []);

    const rowFetch = async () => {
        setLoading(true)
        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/get_uploaded_filesdata",
            {},
            true,
            false
        );
        if (response?.status === "success") {

            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);
            setStatusOptions(response?.body?.filters?.status)
            setLoading(false)


        } else {
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue.length < 6) {
            setLoc(numericValue);
        }
    };

    const downloadFile = async (path) => {
        if (selectedOption === "Custom") {
            if (startDate == null || endDate == null) {
                setmessage("Please select start and end date.");
                setmodalOpener(true);
                return;
            }
        }
        setLoading(true)
        const formattedStartDate = moment(new Date(startDate)).format('YYYY-MM-DD');
        const formattedEndDate = moment(new Date(endDate)).format('YYYY-MM-DD');

        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "TO_DATA",
                "creation_date": selectedOption === "Select Creation Date" ? null : selectedOption,
                "status": status,
                "start_date": selectedOption === "Custom" ? formattedStartDate : null,
                "end_date": selectedOption === "Custom" ? formattedEndDate : null,

            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);
        } else if (response?.status === "error") {
            setLoading(false)

            setmessage(response?.body?.message);
            setmodalOpener(true);
        }
        else {
            setLoading(false)

            setmessage(response?.message);
            setmodalOpener(true);
        }


    };
    const handleDownloadAssetMaster = async () => {
        if (loc == '') {
            setmessage("Please enter location code.");
            setmodalOpener(true);
            return;
        }
        if (loc.length < 3 || loc.length > 5) {
            setmessage("Please enter a valid location code (3-5 digits).");
            setmodalOpener(true);
            return;
        }
        setLoading(true)

        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "ASSET",
                "loc": loc
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)
            setLoc("")
            window.open(response?.body?.data);
        }
        else {
            setLoading(false)
            setLoc("")
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }

    }

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        const currentDate = new Date();
        if (event.target.value === "Last 7 days") {
            setStartDate(new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Last 30 days") {
            setStartDate(new Date(currentDate.getTime() - 29 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Custom") {
            setStartDate(null);
            setEndDate(null);
        }
    };

    const handleStartDateChange = (date) => {
        setStartDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : null);
    };
    const handleEndDateChange = (date) => {
        setEndDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59) : null);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
    };

    const handleDownloadSampleFile = async () => {
        setLoading(true)

        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "SAMP"
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);
        } else {
            setLoading(false)

            setmessage(response?.message);
            setmodalOpener(true);
        }

    };
    const downloadLocationMaster = async () => {
        setLoading(true)
        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "LOC"
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)

            window.open(response?.body?.data);
        } else {
            setLoading(false)

            setmessage(response?.message);
            setmodalOpener(true);
        }

    };
    const handleDownloadAMFile = async () => {
        setLoading(true)
        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "AM"
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);
        } else {
            setLoading(false)
            setmessage(response?.message);
            setmodalOpener(true);
        }

    };
    // imageupload 
    // file upload
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const handleSaveData = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }



            setLoading(true)

            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base +
                "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/gen_pre_url",
                {
                    filename: filenameWithTimestamp?.replace(/[()]/g, ""),
                },
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }
            const presignedUrl = presignedUrlResponse.data.response;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/save_to_data",
                        {
                            // filename: filenameWithTimestamp,
                            filename: presignedUrl.fields.key
                        },
                        true,
                        false
                    );
                    if (response?.status === "success") {

                        setLoading(false)
                        setmessage("File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2500);

                    } else if (response?.status === "error") {
                        setLoading(false)

                        setmessage(response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2500);
                    }

                    else {
                        setLoading(false)

                        setmessage(response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)

            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }

    const handleViewReason = (row) => {
        setViewReasonRow(row);
    };

    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/download_data",
            {
                "type": "PROCESS_LOG",
                log_id: logId,
            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);

        } else {
            setLoading(false)
            setmessage(response?.body?.message);
            setmodalOpener(true);
        }
    }
    const HoverCell = ({ value }) => {
        return (
            <Tooltip
                title={
                    <span style={{ fontSize: "16px" }}>{value}</span>
                }
            >
                <div
                    style={{
                        whiteSpace: "none",
                        textAlign: "start",
                        maxWidth: "100%",
                    }}
                >{value}</div>
            </Tooltip>
        );
    };

    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr no',
            headerAlign: 'center',
            align: 'center',
            flex: 0.5,
            renderCell: (params) => (
                <div>
                    {params.id}
                </div>
            )
        },
        {
            field: "file_name",
            headerName: "File Name",
            flex: 1.5,
            wordBreak: "break-word",
            width: 150,
            renderCell: (params) => {
                return <HoverCell value={params.value} />;
            },
        },
        {
            field: 'created_at',
            headerName: 'Date',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params.value}</div>
            ),
        },
        {
            field: 'log_id',
            headerName: 'Request Id',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params.value}</div>
            ),
        },
        {
            field: 'to_num',
            headerName: 'Order No.',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params.value > 0 ? params.value : '--'}</div>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{
                    textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red',
                }}>{params.value}</div>
            ),
        }, ,
        {
            field: 'no_of_records',
            headerName: (
                <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                    No of records processed
                </div>
            ),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: "progress",
            headerName: "Progress",
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: (params) => {
                return (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        height="100%"
                        textAlign="center"
                        style={{
                            lineHeight: 1.5,
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "0.9rem",
                                marginBottom: "4px",
                                color: params.value === 'TO Rejected' ? 'red' : params.value === 'TO Submitted' && 'green'
                            }}
                        >
                            {params.value}
                        </Typography>
                        {params.value === "TO Rejected" &&
                            <Box
                                component="span"
                                style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                }}
                                onClick={() => handleViewReason(params.row)}
                            >
                                View Reason
                            </Box>
                        }

                    </Box>
                );
            },
        }
        ,
        ,


        {
            field: "process_log",
            headerName: "Process Log",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={styles.processLogCell}>
                    <IconButton
                        aria-label="Download Process Log"
                        onClick={() => downloadProcessLog(params.row.log_id)}
                    >
                        <Download color="primary" />
                    </IconButton>
                </div>
            ),
        }
    ];


    return (
        <div style={styles.container}>
            <Typography style={styles.title}> Create transfer requests </Typography>
            <Divider sx={styles.divider} />
            <div style={styles.sectionContainer}>
                <Card sx={styles.card} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Download TO request details"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                    />
                    <Divider />
                    <CardContent sx={styles.cardContent} >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <Typography sx={styles.label}>Creation Date:</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} lg={3}>
                                <Select
                                    size="small"
                                    value={selectedOption}
                                    onChange={handleOptionChange}
                                    renderValue={(selected) => {
                                        switch (selected) {
                                            case "Last 7 days":
                                                return `${formatDate(
                                                    new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000)
                                                )} - ${formatDate(today)}`;
                                            case "Last 30 days":
                                                return `${formatDate(
                                                    new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000)
                                                )} - ${formatDate(today)}`;

                                            default:
                                                return selected;
                                        }
                                    }}
                                    sx={styles.select}
                                >
                                    <MenuItem value="Last 7 days" sx={styles.label}>
                                        Last 7 days
                                    </MenuItem>
                                    <MenuItem value="Last 30 days" sx={styles.label}>
                                        Last 30 days
                                    </MenuItem>
                                    <MenuItem value="Custom" sx={styles.label}>
                                        Custom
                                    </MenuItem>
                                </Select>
                            </Grid>
                            <Grid item >
                                <Typography sx={styles.label}>Status:</Typography>
                            </Grid>

                            <Grid item xs={12} sm={4} md={3} lg={3}>
                                <FormControl
                                    sx={styles.formControl}
                                >
                                    <Select
                                        displayEmpty
                                        size="small"
                                        sx={styles.label}
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em sx={{ fontSize: 15 }}>Select Status</em>
                                        </MenuItem>
                                        {statusOptions?.length > 0 &&
                                            statusOptions?.map((option) => (
                                                <MenuItem
                                                    key={option}
                                                    value={option}
                                                    sx={{ fontSize: 15 }}
                                                >
                                                    {option}
                                                </MenuItem>
                                            ))}
                                    </Select>

                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={2} md={3} sm={2} xs={12}>
                                <Box display="flex" justifyContent="flex-end">
                                    <SSPCommonButton
                                        btnText={"Download"}
                                        btnFunction={() => downloadFile()}
                                    // loading={loading}
                                    // loadingText="Downloading File..."
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        {selectedOption === "Custom" && (
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                <Grid item ></Grid>
                                <Grid item>
                                    <Typography sx={[styles.label, { marginLeft: 1 }]}>Start Date:</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <StyledDatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        maxDate={new Date()}
                                    />
                                </Grid>

                                <Grid item>
                                    <Typography sx={styles.label}>End Date:</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <StyledDatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        minDate={startDate}
                                        maxDate={new Date()}
                                    />
                                </Grid>
                            </Grid>
                        )}

                    </CardContent>
                </Card>
                <Card sx={styles.card}>
                    <CardHeader
                        p={2}
                        sx={styles.locationCodeCardHeader}
                        title={"Download asset master details at a location"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                    />
                    <Divider />
                    <CardContent sx={styles.locationCardContent}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={4} lg={6}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                    <Typography>Enter Location Code:</Typography>
                                    <TextField
                                        rows={1}
                                        variant='outlined'
                                        label=""
                                        value={loc}
                                        size="small"
                                        onChange={handleChange}
                                        autoFocus={false}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={6} >
                                <Box sx={{ display: "flex", justifyContent: 'center', marginLeft: '6rem' }}>
                                    <SSPCommonButton
                                        btnText={"Download Asset Master"}
                                        btnFunction={handleDownloadAssetMaster}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card
                    sx={styles.card}
                >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={" Upload excel containing TO request data"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                    />
                    <Divider />
                    <CardContent
                        sx={styles.cardContent}
                    >
                        <Box sx={styles.fullWidth}>
                            <Grid container rowSpacing={1}>
                                <Grid item xs={6} sx={styles.whiteBackgrnd}>
                                    <Typography>
                                        <b style={styles.redColor}>*&nbsp;</b>
                                        Upload Sample File
                                    </Typography>
                                    <Box
                                        p={2}
                                        sx={{
                                            display: { lg: "flex", md: "flex" },
                                            gap: "1rem",
                                        }}
                                    >
                                        <Box
                                            p={1}
                                            sx={{
                                                border: "1px solid lightgrey",
                                                borderRadius: "5px",
                                                marginBottom: { sm: "1rem" },
                                            }}
                                        >
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                multiple={false}
                                                onChange={(e) => {
                                                    setSelectedFile(e.target.files[0]);
                                                }}

                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} >
                                    <Box
                                        sx={styles.saveDataButton}
                                    >
                                        <SSPCommonButton
                                            btnText={"SAVE DATA"}
                                            btnFunction={handleSaveData}
                                        // loading={loading}
                                        // loadingText="Saving..."
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Box
                                p={1}
                                sx={styles.buttonBox}
                            >
                                <Link
                                    component={"button"}
                                    color={"#0160F1"}
                                    sx={boxSX}
                                    onClick={handleDownloadSampleFile}
                                >
                                    {"Download Sample File"}
                                </Link>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={styles.deviderStyle}
                                />
                                <Link
                                    component={"button"}
                                    color={"#0160F1"}
                                    sx={boxSX}
                                    onClick={downloadLocationMaster}
                                >
                                    {"Download Location Master"}
                                </Link>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={styles.deviderStyle}
                                />
                                <Link
                                    component={"button"}
                                    color={"#0160F1"}
                                    sx={boxSX}
                                    onClick={handleDownloadAMFile}
                                >
                                    {"Download Approval Matrix"}
                                </Link>
                            </Box>
                        </Box>
                    </CardContent>

                </Card>
                {loading && (
                    <div style={styles.loaderOverlay}>
                        <CircularProgress />
                    </div>
                )}
                <Card
                    sx={styles.card}
                >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    {/* Table */}
                    <CardContent
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderBottomRightRadius: "5px",
                            borderBottomLeftRadius: "5px",
                        }}

                    >
                        <Box
                            sx={{
                                display: { lg: "flex" },
                            }}
                        >
                        </Box>
                        <div>
                            <div style={{ height: 700, width: '100%' }}>
                                <DataGrid

                                    rowHeight={80}
                                    showCellRightBorder={true}
                                    sx={{
                                        ".MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "bold !important",
                                        },
                                        overflowX: "scroll",
                                    }}
                                    rows={row}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    checkboxSelection={false}
                                    isRowSelectable={(params) =>
                                        params.row.approve_status === 'Pending'
                                    }
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setSelectedRowIds(newRowSelectionModel);
                                    }}
                                    headerClassName="header-center"
                                    rowsPerPageOptions={[10]}
                                    pageSize={10}
                                    getRowId={(row) => row.id}
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                    componentsProps={{
                                        Toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        {viewReasonRow && (
                            <Dialog
                                open={viewReasonRow !== null}
                                onClose={() => setViewReasonRow(null)}
                            >
                                <DialogTitle
                                    sx={{ fontWeight: "bold", fontSize: 18 }}
                                >{`Log id - ${viewReasonRow.log_id} : Rejection Details`}</DialogTitle>
                                <Divider />
                                <DialogContent>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginTop: "8px",
                                        }}
                                    >
                                        <Typography sx={{ marginRight: "8px" }}>
                                            Rejection Reason :
                                        </Typography>
                                        <Box
                                            sx={{
                                                border: "1px solid #ccc",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                maxWidth: 300,
                                                minWidth: 200,
                                                textAlign: "center",
                                            }}
                                        >

                                            {viewReasonRow?.to_rejection_reason}
                                        </Box>
                                    </div>
                                </DialogContent>
                            </Dialog>
                        )}

                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>

            </div>
            <SSPCommonVideo
                headerText={"Demo Video"}
                videoUrl={"https://www.youtube.com/embed/jQWBuJWFxFs"}
            />
        </div>
    )
}

export default CreateTransferReqest;
